import type { ISkillData } from '../types';
import { getSkillDisplayName } from './display';

/**
 * 获取详情页推荐 Skill 列表（同分类、排除当前 Skill，按使用量降序）
 * @param allSkills - 全量 Skill 列表
 * @param currentSkillId - 当前 Skill ID
 * @param limit - 最大条数
 */
export const getRecommendSkills = (
  allSkills: ISkillData[],
  currentSkillId: string,
  limit = 3,
): ISkillData[] => {
  const currentSkill = allSkills.find((item) => item.skill_id === currentSkillId);
  const currentCategoryId = currentSkill?.category_id?.trim();

  if (!currentCategoryId) {
    return [];
  }

  return allSkills
    .filter(
      (item) =>
        item.skill_id !== currentSkillId
        && item.category_id === currentCategoryId,
    )
    .sort((a, b) => (b.dialog_count ?? 0) - (a.dialog_count ?? 0))
    .slice(0, limit);
};

/**
 * 解析推荐 Skill 展示名
 * @param skill - Skill 数据
 * @param isEN - 是否英文
 */
export const getRecommendSkillLabel = (
  skill: ISkillData,
  isEN: boolean,
): string => getSkillDisplayName(skill, isEN);
